export default {
      id: "photo-usage",
      viewBox: "0 0 32.704 25.741",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#photo",
      toString: function () {
        return this.url;
      }
    }